export const billing = '/billing';
export const events = '/events';
export const permissions = '/permissions';
export const users = '/users';
export const upload = '/upload';
export const tracking = '/tracking';
